import { useQuery } from "@tanstack/react-query";
import { roleFamiliesApi } from "./api";

const ROLE_FAMILY_STALE_MS = 5 * 60_000;

export function useRoleFamilyCatalog(enabled = true) {
  const query = useQuery({
    queryKey: ["role-family-catalog"],
    queryFn: () => roleFamiliesApi.catalog(),
    enabled,
    staleTime: ROLE_FAMILY_STALE_MS,
  });
  const options = (query.data?.options ?? []).map((row) => ({
    value: row.code,
    label: row.label,
  }));
  return { ...query, options, labels: query.data?.labels };
}
